export default import.meta.ROLLDOWN_FILE_URL_KCX0zRYJrYRhEJsotaZb_A